<script lang="ts">
import { defineComponent } from "vue";
import AppModal from "@/components/AppModal.vue";
import InfoIcon from "@/components/icons/InfoIcon.vue";
import { useStore } from "@/store/hooks"; // Import the typed hook
import { RootState } from "@/store/types";

export default defineComponent({
  setup() {
    const store = useStore();

    const close = () => {
      store.dispatch("ErrorModalStore/toggleErrorModal", {
        errorType: "updateOrderError",
      });
    };

    const isErrorModalVisible = (errorType: string): boolean => {
      const errorstore = store?.state
        ?.ErrorModalStore as RootState["ErrorModalStore"];
      return errorstore.showModal && errorstore.errorType === errorType;
    };

    return {
      store,
      close,
      isErrorModalVisible,
    };
  },
  components: { AppModal, InfoIcon },
});
</script>
<template>
  <AppModal
    id="parallel-edit-modal"
    :visible="isErrorModalVisible('updateOrderError')"
    modalType="accept"
    cancelText="tour.ok"
    @hide-modal="close"
  >
    <!-- Modal body -->
    <div
      v-if="isErrorModalVisible('updateOrderError')"
      class="p-6 flex flex-col w-full justify-center"
      data-testid="test-cancel-tour"
    >
      <InfoIcon></InfoIcon>
      <h2 class="font-bold">
        {{ $t("order.error.update_title") }}
      </h2>
      <br />
      <h2 class="font-bold">
        {{ $t("order.error.update_text") }}
      </h2>
    </div>
  </AppModal>
</template>
